import { gql } from '@apollo/client';

export const GET_UNLOADING_ORDER_DETAIL_WAYPOINT_PARCEL_COUNTS_BY_TASK_ID = gql`
    query GetUnloadingOrderDetailWaypointParcelCountsByTaskId($taskId: Long!) {
        getUnloadingOrderDetailWaypointParcelCountsByTaskId(taskId: $taskId) {
            waypointId
            parcelCount
        }
    }
`;

export interface TmsWaypointParcelCountType {
    waypointId: number;
    parcelCount: number;
}

export interface GetUnloadingOrderDetailWaypointParcelCountsByTaskIdResponse {
    getUnloadingOrderDetailWaypointParcelCountsByTaskId: TmsWaypointParcelCountType[];
}

export interface GetUnloadingOrderDetailWaypointParcelCountsByTaskIdVariables {
    taskId: number;
}

